import { useEffect, useState } from "react";
import { getApp } from "firebase/app";
import {
  getStripePayments,
  getCurrentUserSubscriptions,
} from "@invertase/firestore-stripe-payments";
import { useAuth } from "../context/AuthContext";

const app = getApp();
const payments = getStripePayments(app, {
  productsCollection: "products",
  customersCollection: "customers",
});

export function useIsPremium() {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [isPremium, setIsPremium] = useState(false);

  useEffect(() => {
    let mounted = true;
    if (!currentUser) {
      setIsPremium(false);
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const subs = await getCurrentUserSubscriptions(payments, {
          status: "active",
        });
        if (mounted) setIsPremium((subs || []).length > 0);
      } catch {
        if (mounted) setIsPremium(false);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [currentUser]);

  return { isPremium, loading };
}
